<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav myFont">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="isRTL ? 'حساب کاربری' : 'حساب کاربری'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/account"
          :class="getRoute() === 'account' ? 'active' : ''"
          :navText="isRTL ? 'حسابداری' : 'حسابداری'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/billing"-->
<!--          :class="getRoute() === 'billing' ? 'active' : ''"-->
<!--          :navText="isRTL ? 'تسویه ها' : 'تسویه حساب'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/virtual-reality"-->
<!--          :class="getRoute() === 'virtual-reality' ? 'active' : ''"-->
<!--          :navText="isRTL ? 'الواقع الافتراضي' : 'Virtual Reality'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-app text-info text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/rtl-page"-->
<!--          :class="getRoute() === 'rtl-page' ? 'active' : ''"-->
<!--          navText="RTL"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->

      <li class="mt-3 nav-item">
        <h6
          v-if="isRTL"
          style="text-align: right"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          جزییات حساب کاربری
        </h6>

        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          جزییات حساب کاربری
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'پروفایل' : 'پروفایل'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/signin"-->
<!--          :class="getRoute() === 'signin' ? 'active' : ''"-->
<!--          :navText="isRTL ? 'ورود به حساب کاربری' : 'ورود به حساب کاربری'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->

<!--      <li class="nav-item">-->
<!--        <sidenav-item-->
<!--          to="/signup"-->
<!--          :class="getRoute() === 'signup' ? 'active' : ''"-->
<!--          :navText="isRTL ? 'اشتراك' : 'ایجاد حساب کاربری'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-collection text-info text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
<!--      </li>-->
    </ul>
  </div>

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :card="{
        title: 'Need Help?',
        description: 'Please check our docs',
        links: [
          {
            label: 'Documentation',
            route:
              'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',
            color: 'dark',
          },
          {
            label: 'Buy now',
            route:
              'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',
            color: 'success',
          },
        ],
      }"
    />
  </div>
</template>
<style scoped>
.myFont{
  font-family: Tahoma !important;
}
</style>